<mat-card fxFlex class="card-table has-progress-bar">
  <mat-progress-bar [mode]="(progress$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>

  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <span>{{ 'patient-details.insurance-card.title' | translate }}</span>
    <button
      *appHasPermission="'patient-insurance.edit'"
      mat-stroked-button
      (click)="onAddInsuranceClick()"
    >
      <mat-icon>add</mat-icon>
      <span>{{ 'patient-details.insurance-card.button-add' | translate }}</span>
    </button>
  </mat-card-title>

  <mat-card-content fxLayout="column">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="carrier">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'patient-details.insurance-card.table.carrier' | translate }}
        </th>
        <td mat-cell *matCellDef="let insurance">
          {{ insurance.clinicCarrierName || insurance.clinicCarrierId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'patient-details.insurance-card.table.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let insurance">
          <ng-container [ngSwitch]="insurance.status">
            <div *ngSwitchCase="PatientInsuranceStatus.Active" fxLayout="column">
              <span>{{ 'common.active' | translate }}</span>
              <small *ngIf="insurance.lastVerifiedAt">
                Last Verified {{ insurance.lastVerifiedAt | momentDate: appointment?.timezone ?? 'local' }}
                <ng-container *ngIf="insurance.lastVerifiedBy">
                  by {{ insurance.lastVerifiedBy }}
                </ng-container>
              </small>
            </div>
            <span *ngSwitchCase="PatientInsuranceStatus.Inactive">{{ 'common.inactive' | translate }}</span>
            <span *ngSwitchDefault>{{ 'dialog.insurance.not-verified' | translate }}</span>
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="member">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'patient-details.insurance-card.table.member' | translate }}
        </th>
        <td mat-cell *matCellDef="let insurance">
          <div fxLayout="column">
            <mmx-copy-text>{{ insurance.memberId || '' }}</mmx-copy-text>
            <ng-container *ngIf="insurance.groupNumber">
              <div class="text-sm">{{ insurance.groupNumber }}</div>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'patient-details.insurance-card.table.type' | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let insurance; let i = index"
        >
          {{ 'insurances.type.' + insurance.type | translate }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'patient-details.insurance-card.table.actions' | translate }}
        </th>
        <td mat-cell *matCellDef="let insurance">
          <button mat-icon-button [matMenuTriggerFor]="options">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #options="matMenu">
            <button
              *appHasPermission="'patient-insurance.edit'"
              mat-menu-item
              type="button"
              (click)="onEditInsuranceClick(insurance)"
            >
              <mat-icon>edit</mat-icon>
              {{ 'common.edit' | translate }}
            </button>

            <ng-container *ngIf="!insurance.lookupType || insurance.lookupType === INSURANCE_PROVIDER_LOOKUP_TYPE.MEDICAL_INSURANCE">
              <button
                *appHasPermission="'patient.eligibility.edit'"
                mat-menu-item
                type="button"
                (click)="onPullEligibilityClick(insurance)"
                [color]="insurance.carrierId ? undefined : 'warn'"
              >
                <mat-icon>policy</mat-icon>
                {{ 'patient-details.eligibility-card.button-pull-eb' | translate }}
              </button>
            </ng-container>

            <ng-container *ngIf="insurance.eligibilityId && !embedded">
              <a *appHasPermission="'patient.eligibility.view'"
                mat-menu-item
                [routerLink]="['/patient', insurance.patientId, 'appointment', appointment?.id, 'eligibility', insurance.eligibilityId]"
                target='_blank'>
                <mat-icon>shield</mat-icon>
                {{ 'patient-details.eligibility-card.view-eb' | translate }}
              </a>

              <!-- <button mat-menu-item (click)="openRawResponse()">
                <mat-icon>code</mat-icon>
                <span>{{
                  'patient-details.eligibility-card.view-raw-response' | translate
                  }}</span>
              </button> -->
            </ng-container>

            <ng-container *appHasPermission="'patient-insurance.delete'">
              <mat-divider></mat-divider>

              <button mat-menu-item (click)="deleteInsurance(insurance)">
                <mat-icon color="warn">delete</mat-icon>
                {{ 'common.delete' | translate }}
              </button>
            </ng-container>

            <ng-container *appHasPermission="'setting.edit'">
              <mat-divider></mat-divider>

              <a
                mat-menu-item
                *mmxConsoleOnly
                [routerLink]="['carrier', insurance.carrierLookupId]">
                {{ 'patient-details.insurance-card.open-carrier-settings' | translate }}
              </a>
            </ng-container>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="insuranceTableColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: insuranceTableColumns"
        [class.row-muted]="row.status === 'I'"
      ></tr>
    </table>
  </mat-card-content>
</mat-card>
